import React, { useEffect } from 'react';
import { usePatientData } from './hooks/PatientData.hook';
import { useSelector } from 'react-redux';
import PatientDataView from './views/PatientDataView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const PatientDataController = () => {
  const lenguage = useSelector(state => state.lenguage?.lang);

  const {
    isLoading,
    patient,
    paises,
    departamentos,
    provincias,
    distritos,
    savePatient,
    changePatientPassword,
  } = usePatientData();

  useEffect(() => {
    if (patient) {
      console.log('Datos del paciente cargados correctamente:', patient);
    }
  }, [patient]);

  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  }

  return (
    <PatientDataView
      lenguage={lenguage}
      patient={patient}
      paises={paises}
      departamentos={departamentos}
      provincias={provincias}
      distritos={distritos}
      onSavePatient={savePatient}
      onChangePassword={changePatientPassword}
    />
  );
};

export default PatientDataController;
